import type { IAhuBoardTunnel, IAhuBoardUnit } from 'models';

/**
 * `fn.tools.getHybridLugFieldValue('lug', tunnel, ahu)`
 * (ahu/mvc/view/fn_tools.js:1155-1167).
 *
 * "Include Lifting Lugs" is a per-tunnel flag on a standard AHU and an
 * AHU-wide one on a hybrid, where the Base & Lugs settings belong to the unit
 * rather than to one tunnel: `sync_hybrid_lugs` reads `ahu.lug`
 * (base_group_lug.py:245) and a hybrid tunnel's own `lug` column is left
 * false. Legacy funnels every lug gate — canvas draw, the pane, the
 * per-tunnel placement fetch — through this one helper for exactly that
 * reason; reading `tunnel.lug` directly is the pre-hybrid shape and is always
 * false on a hybrid AHU.
 */
export const lugsOnForTunnel = (
  ahu: Pick<IAhuBoardUnit, 'is_hybrid' | 'lug'> | undefined | null,
  tunnel: Pick<IAhuBoardTunnel, 'lug'> | undefined | null
): boolean => (ahu?.is_hybrid ? !!ahu?.lug : !!tunnel?.lug);
